// When we have feature flag in play - import the flag from the featureKeys file eg:
// import { REACT_ADVANCED_TIMELINE } from 'js/config/featureKeys';
import { ADVANCED_TIMELINE_V4 } from 'js/config/featureKeys';

import getOptimizelyInstance from './optimizely';

const RUNNING_EXPERIMENTS_TO_TRACK: Array<string> = [];
const RUNNING_FEATURE_FLAGS_TO_TRACK: Array<string> = [ADVANCED_TIMELINE_V4];

export async function getExperimentAndFlagsUserPropertiesForTracking(
  experiments = RUNNING_EXPERIMENTS_TO_TRACK,
  flags = RUNNING_FEATURE_FLAGS_TO_TRACK
): Promise<{ [key: string]: string }> {
  const optimizely = getOptimizelyInstance();

  if (!optimizely) return {};

  try {
    await optimizely.onReady({ timeout: 6000 });
  } catch (_) {
    console.warn(
      'Optimizely failed to initialize within the timeout period, returning empty experiment properties for tracking'
    );
    return {};
  }

  const decisions = optimizely.decideForKeys(experiments);
  const experimentUserProperties: { [key: string]: string } = Object.entries(decisions).reduce(
    (properties, [experimentKey, decision]) => {
      return {
        ...properties,
        [`Experiment: ${experimentKey}`]: decision.variationKey
      };
    },
    {}
  );

  flags.forEach(flag => {
    const enabled = optimizely.isFeatureEnabled(flag);
    experimentUserProperties[`Feature Flag "${flag}" Status`] = enabled ? 'Enabled' : 'Disabled';
  });

  return experimentUserProperties;
}
